import { useTranslation } from 'react-i18next'
import { fmt, pct } from './format'

const COLUMNS = [
  ['kcal', (v) => fmt(v, 0)], ['carbs_g', (v) => fmt(v, 0)], ['sweet_baked_kcal', (v) => fmt(v, 0)],
  ['alcohol_day_share', pct], ['sleep_minutes', (v) => fmt(v, 0)], ['resting_hr', (v) => fmt(v, 0)], ['training_share', pct],
]

/** VH-222: the weekday structure behind many couplings. */
export default function WeekdayTable({ rows = [] }) {
  const { t } = useTranslation()
  if (rows.length === 0) return null
  return (
    <section className="space-y-2" data-testid="weekday-table">
      <h3 className="text-base font-semibold">{t('systemView.weekday.title')}</h3>
      <p className="text-xs text-gray-600">{t('systemView.weekday.intro')}</p>
      <div className="overflow-x-auto">
        <table className="min-w-full text-xs">
          <thead>
            <tr className="text-left text-gray-600">
              <th className="py-1 pr-3">{t('systemView.weekday.day')}</th>
              {COLUMNS.map(([k]) => <th key={k} className="py-1 pr-3">{t(`systemView.weekday.columns.${k}`)}</th>)}
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.weekday} className="border-t">
                <td className="py-1 pr-3">{t(`systemView.weekday.days.${r.weekday}`)}</td>
                {COLUMNS.map(([k, f]) => <td key={k} className="py-1 pr-3">{f(r[k])}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  )
}
